import { CommonEditContext, CreateCommonSearchContext } from "./common-data.model";

export const DefaultKpiOthers = {
  search: CreateCommonSearchContext(),
  edit: {
    editForm: {
      model: {} as KpiOthersEditCriteria,
      dirty: false,
      status: null as any,
      errors: null as any
    },
  } as CommonEditContext<KpiOthersEditCriteria>,
}

export interface KpiOthersEditCriteria {
  kpiOthers_Id: number;

  driver_Id: number;
  kpi_Id: number;

  apexId: string;
  driverName: string;

  kpiTime: string;
  title: string;
  description: string;
  attachment: string;
}
